import { render } from "./TotalUsersPage.vue?vue&type=template&id=0fbcb269&scoped=true"
import script from "./TotalUsersPage.vue?vue&type=script&lang=js"
export * from "./TotalUsersPage.vue?vue&type=script&lang=js"

import "./TotalUsersPage.vue?vue&type=style&index=0&id=0fbcb269&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fbcb269"

export default script